import React from "react";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { RichContent } from "../components/RichText";
import { sized, srcSet } from "../lib/api";
import { useContent } from "../context/ContentContext";

export default function About() {
  const { p } = useContent();
  const c = p("about");
  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14" data-testid="about-page">
      <Seo title="About — CaminoSapiens" description="CaminoSapiens is a small working art studio making hand-pulled photogravure etchings inspired by long-distance walking, observation, and memory." />
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "About" }]} />

      <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div className="overflow-hidden border border-[#E4E1DB]">
          <img src={sized(c.header.image, 1200)} srcSet={srcSet(c.header.image, [600, 900, 1400])} sizes="(min-width:1024px) 50vw, 100vw" alt={c.header.image_alt} className="w-full h-[560px] object-cover" loading="lazy" />
        </div>
        <div>
          <p className="overline mb-4">{c.header.eyebrow}</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-tight">{c.header.heading}</h1>
          <RichContent html={c.header.body} className="mt-8" />
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-8 mt-24 border-t border-[#E4E1DB] pt-16">
        {(c.values.items || []).map((v) => (
          <div key={v.t}><p className="overline mb-2">{v.t}</p><p className="text-[#4A4947] leading-relaxed">{v.d}</p></div>
        ))}
      </div>

      <div className="text-center mt-24">
        <Link to={c.values.cta_link} className="inline-block bg-[#1C1B1A] text-[#F9F8F6] px-8 py-4 text-sm hover:bg-[#B35D4B] transition-colors">{c.values.cta_label}</Link>
      </div>
    </div>
  );
}
